import { makeStyles } from '@material-ui/core/styles';

export default () => {
    const useStyles = makeStyles(theme => ({
        content: {
            flexGrow: 1,
            // padding: theme.spacing(3),
          },
          main: {
            
        }
    }));

    return useStyles;
}